RivalIQ.apps.CompanyProfile.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const widgets = [
        {
            instanceId: 'facebook',
            widgetId: RivalIQ.enums.widgetTypes.COMPANY_CHANNEL,
            props: {
                channel: RivalIQ.enums.channels.FACEBOOK
            }
        },
        {
            instanceId: 'instagram',
            widgetId: RivalIQ.enums.widgetTypes.COMPANY_CHANNEL,
            props: {
                channel: RivalIQ.enums.channels.INSTAGRAM
            }
        },
        {
            instanceId: 'twitter',
            widgetId: RivalIQ.enums.widgetTypes.COMPANY_CHANNEL,
            props: {
                channel: RivalIQ.enums.channels.TWITTER
            }
        },
        {
            instanceId: 'youtube',
            widgetId: RivalIQ.enums.widgetTypes.COMPANY_CHANNEL,
            props: {
                channel: RivalIQ.enums.channels.YOUTUBE
            }
        },
        {
            instanceId: 'tiktok',
            widgetId: RivalIQ.enums.widgetTypes.COMPANY_CHANNEL,
            props: {
                channel: RivalIQ.enums.channels.TIKTOK
            }
        }
    ];

    const Layout = Dashboard.views.CurationWidgets.extend({
        template: '#companyChannelLayoutTemplate',
        templateHelpers: function () {
            const me = this;
            return {
                hasBackToLandscapeLink: function () {
                    const from = me.getProp('from');
                    return (from === RivalIQ.enums.curation.COMPANIES);
                }
            };
        }
    });

    curations.Channels = Dashboard.models.Curation.mixin({
        beforeFilters: [
            curations.filters.loadCompanies
        ],

        mixins: {
            CompanySwitchable: Dashboard.mixins.CompanySwitchable
        },

        getExportTitle: function () {
            const me = this;
            return me.company.get('name');
        },

        getPptTitle: function () {
            const me = this;
            return me.company.get('name');
        },

        getTitleSlide: function () {
            const me = this;

            return RivalIQ.apps.Reports.models.Slide.createIntro(
                me,
                // TODO manage w/ params, not state
                RivalIQ.state.view.get('landscapeName'),
                undefined // Dont show focus company
            );
        },

        widgetsView: Layout,
        companySets: false,
        page: RivalIQ.configuration.menus.getConfiguration().COMPANY_PROFILE,
        getBasePath: function (overrides) {
            overrides = overrides || {};
            const me = this;
            const props = _.defaults(overrides, {
                companyId: me.getProp('companyId')
            });
            return me.router.resolveCurationRoute(me.id, props);
        },
        widgetDefinitions: widgets
    });

});
